var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.70005 0.800049C1.20303 0.800049 0.800049 1.20297 0.800049 1.70005V3.50005C0.800049 3.99713 1.20303 4.40005 1.70005 4.40005H3.50005C3.99707 4.40005 4.40005 3.99713 4.40005 3.50005V1.70005C4.40005 1.20297 3.99707 0.800049 3.50005 0.800049H1.70005ZM1.70005 6.20005C1.20303 6.20005 0.800049 6.60297 0.800049 7.10005V8.90005C0.800049 9.39713 1.20303 9.80005 1.70005 9.80005H3.50005C3.99707 9.80005 4.40005 9.39713 4.40005 8.90005V7.10005C4.40005 6.60297 3.99707 6.20005 3.50005 6.20005H1.70005ZM0.800049 12.5C0.800049 12.003 1.20303 11.6 1.70005 11.6H3.50005C3.99707 11.6 4.40005 12.003 4.40005 12.5V14.3C4.40005 14.7971 3.99707 15.2 3.50005 15.2H1.70005C1.20303 15.2 0.800049 14.7971 0.800049 14.3V12.5ZM15.2 1.70005H6.20005V3.50005H15.2V1.70005ZM6.20005 7.10005H15.2V8.90005H6.20005V7.10005ZM15.2 12.5H6.20005V14.3H15.2V12.5Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListView);
export default __webpack_public_path__ + "static/media/ListView.61a10829fa26a046eca6bb67aa56d49e.svg";
export { ForwardRef as ReactComponent };